import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { API_CONFIG, getApiUrl } from "../config/api";

type AiStatus = { isConnected: boolean; message: string } | null;

const AiStatusContext = createContext<AiStatus>(null);
const AiStatusRefreshContext = createContext<() => void>(() => {});

export const useAiStatus = () => useContext(AiStatusContext);
export const useRefreshAiStatus = () => useContext(AiStatusRefreshContext);

export const AiStatusProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [status, setStatus] = useState<AiStatus>(null);
  // Глобальный флаг, чтобы избежать двойного запроса в StrictMode и при ремонтах
  const hasFetchedRef = React.useRef<boolean>(false);
  const refresh = useMemo(
    () => async () => {
      try {
        const token = localStorage.getItem("token");
        const resp = await fetch(
          `${getApiUrl(API_CONFIG.ENDPOINTS.AI)}/status`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
          }
        );
        if (!resp.ok) throw new Error("failed");
        const data = await resp.json();
        setStatus({
          isConnected: !!data?.isConnected,
          message: data?.message || "",
        });
      } catch (_) {
        setStatus({
          isConnected: false,
          message: "Нет связи с AI ассистентом",
        });
      }
    },
    []
  );
  useEffect(() => {
    if (!hasFetchedRef.current) {
      hasFetchedRef.current = true;
      refresh();
    }
  }, [refresh]);

  return (
    <AiStatusContext.Provider value={status}>
      <AiStatusRefreshContext.Provider value={refresh}>
        {children}
      </AiStatusRefreshContext.Provider>
    </AiStatusContext.Provider>
  );
};
